module.exports = __webpack_public_path__ + "static/media/Assets-10-Si-Mayaa-02.cc32494f.png";